
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/truck-driving-jobs/details/[slug]",
      function () {
        return require("private-next-pages/truck-driving-jobs/details/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/truck-driving-jobs/details/[slug]"])
      });
    }
  